import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType, GenericColumnData } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import Modal from "components/Modal/Modal";
import { roles } from "utils/constant";
import { Button } from "@heroui/react";

const VendorPayList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [kpsTotal, setKpsTotal] = useState<any>({});
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [sortStat, setSortStat] = useState<any>({});
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [billNoFilter, setBillNoFilter] = useState("");
  const [ackNoFilter, setAckNoFilter] = useState("");
  const [openAwbDropdownId, setOpenAwbDropdownId] = useState<number | null>(null); // Track which row's AWB dropdown is open

  // Multi-select state
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [gstTdsPaidModalOpen, setGstTdsPaidModalOpen] = useState(false);
  const [paidType, setPaidType] = useState<"gst" | "tds" | null>(null);
  const [isPaidAction, setIsPaidAction] = useState<boolean>(true); // true = mark as paid, false = mark as unpaid
  const [bulkActionModalOpen, setBulkActionModalOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState<"disburse" | "reject" | null>(null);
  const [bulkRemark, setBulkRemark] = useState("");

  const [query, setQuery] = useState<any>({
    invoiceDate: {
      $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
      $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
    },
  });
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [branchOpt, setBranchOtp] = useState<any>();
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [cityOptions, setCityOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [selectedCity, setSelectedCity] = useState<any>();

  const [selectedStatus, setSelectedStatus] = useState<any>();

  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const [seletedPayment, setSeletedPayment] = useState<any>({});
  const [disburseModalOpen, setDisburseModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const [refNo, setRefNo] = useState<any>("");
  const [paymentDate, setPaymentDate] = useState<any>("");
  const [payType, setPayType] = useState<any>({});

  useQuery(["VendorListApi"], () => ListCommanWay("/admin/vendor/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.vendor_name,
          });
        });
        setBranchOptions(opt);
      }
    },
  });
  useQuery(["CityListApi"], () => ListCommanWay("/admin/city/list", {}, { paginate: 100000 }), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        if (data?.data) {
          Object.values(data?.data?.data)?.forEach((d: any) => {
            opt.push({
              value: d?.id,
              label: d?.city_name,
            });
          });
          setCityOptions(opt);
        }
      }
    },
  });

  const {
    mutate: deleteVendorPayment,
    isLoading: isDeleting,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((id) => CreateCommanWay({ url: "/admin/vendorpayment/deleteMany", data: { isWarning: true, ids: [id] } }), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        setTotals({ grand: 0 });
        UseToast("Payment Removed Successfully", "success");
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: updatePayMutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        setTotals({ grand: 0 });
        refetch();
        setDisburseModalOpen(false);
        setVerifyModalOpen(false);
        setRejectModalOpen(false);
        setGstTdsPaidModalOpen(false);
        setSelectedRows(new Set());
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  // Bulk update mutation for GST/TDS paid
  const { mutate: bulkUpdatePayMutate, isLoading: isBulkUpdating } = useMutation(
    (params: { ids: number[]; updateData: any }) =>
      UpdateCommanWay({
        url: "/admin/vendorpayment/updateBulk",
        data: {
          filter: { id: params.ids },
          data: params.updateData,
        },
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          UseToast("Data Updated Successfully", "success");
          setTotals({ grand: 0 });
          refetch();
          setGstTdsPaidModalOpen(false);
          setBulkActionModalOpen(false);
          setBulkActionType(null);
          setBulkRemark("");
          setSelectedRows(new Set());
          setPaidType(null);
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    },
  );

  // Calculate total for selected rows
  const getSelectedTotal = (type: "gst" | "tds") => {
    let total = 0;
    tableData.forEach((row: any) => {
      if (selectedRows.has(row.id)) {
        if (type === "gst") {
          total += Number(row.cgst || 0) + Number(row.sgst || 0) + Number(row.igst || 0);
        } else {
          total += Number(row.tds || 0);
        }
      }
    });
    return total;
  };

  // Handle select all
  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = tableData.map((row: any) => row.id);
      setSelectedRows(new Set(allIds));
    } else {
      setSelectedRows(new Set());
    }
  };

  // Handle single row select
  const handleRowSelect = (id: number, checked: boolean) => {
    const newSelected = new Set(selectedRows);
    if (checked) {
      newSelected.add(id);
    } else {
      newSelected.delete(id);
    }
    setSelectedRows(newSelected);
  };

  // Handle paid button click
  const handlePaidClick = (type: "gst" | "tds", markAsPaid: boolean = true) => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setPaidType(type);
    setIsPaidAction(markAsPaid);
    setGstTdsPaidModalOpen(true);
  };

  // Handle confirm paid
  const handleConfirmPaid = () => {
    if (!paidType || selectedRows.size === 0) return;

    const ids = Array.from(selectedRows);
    const updateData = paidType === "gst" ? { gstPaid: isPaidAction } : { tdsPaid: isPaidAction };

    bulkUpdatePayMutate({ ids, updateData });
  };

  // Handle bulk disburse/reject
  const handleBulkAction = (type: "disburse" | "reject") => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setBulkActionType(type);
    setBulkRemark("");
    setBulkActionModalOpen(true);
  };

  const handleConfirmBulkAction = () => {
    if (!bulkActionType || selectedRows.size === 0) return;
    const ids = Array.from(selectedRows);
    const updateData =
      bulkActionType === "disburse"
        ? { status: "PAID" }
        : { status: "REJECTED", remark: bulkRemark };
    bulkUpdatePayMutate({ ids, updateData });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_vendorpayments_report_list"],
    () => ListCommanWay("/admin/vendorpayment/list", { ...query }, { paginate: 1000, include: ["_vendor"] }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.rows);
          setSortStat({});

          let ary = [...data.data.rows];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,
            tds: 0,
            payable: 0,
          };

          let kps = {};
          ary.forEach((a) => {
            //console.log(a.base_value);
            ttt.base += Number(a.basicAmount || 0);
            ttt.cgst += Number(a.cgst) || 0;
            ttt.sgst += Number(a.sgst) || 0;
            ttt.igst += Number(a.igst) || 0;
            ttt.utgst += Number(a.utgst || 0) || 0;
            ttt.grand += Number(a.finalAmount) || 0;
            ttt.tds += Number(a.tds) || 0;
            ttt.payable += (Number(a.finalAmount) || 0) - (Number(a.tds) || 0);

            if (!kps[a.status]) {
              kps[a.status] = [0, 0, 0];
            }
            kps[a.status][0]++;
            kps[a.status][1] += Number(a.finalAmount) || 0;
            kps[a.status][2] += Number(a.tds) || 0;
          });
          setTotals(ttt);
          setKpsTotal(kps);
        } else {
          setTableData([]);
          setKpsTotal({});
        }
      },
      onError: (data) => {
        setTableData([]);
        setKpsTotal({});
      },
    },
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    console.log(selectedStatus);
    setQuery({
      ...(billNoFilter || ackNoFilter
        ? {} // Exclude invoiceDate if billNo or ackNo is present
        : {
            invoiceDate: {
              $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
              $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
            },
          }),
      vendor: branchOpt?.value,
      billNo: billNoFilter ? billNoFilter : undefined,
      id: ackNoFilter ? ackNoFilter : undefined,
      city: selectedCity?.value,
      status: selectedStatus?.value || undefined,
    });
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Vendor Payment Report.xlsx");
  };

  const exportTdsReport = () => {
    // Create TDS report data
    const tdsData = tableData.map((r: any) => {
      const invoiceDate = moment(r.invoiceDate, "DD-MM-YYYY HH:mm:ss");
      const recvDate = moment(r.recvDate, "DD-MM-YYYY HH:mm:ss");
      const noOfMonths = Math.max(0, recvDate.diff(invoiceDate, "months"));
      const tdsRate = Number(r._vendor?.tds) || 0;
      const tdsAmount = Number(r.tds) || 0;
      const interest = Number((tdsAmount * 0.015 * noOfMonths).toFixed(2));
      const panNo = r._vendor?.gst_type || "";
      const fourthLetterOfPan = panNo.length >= 4 ? panNo.charAt(3).toUpperCase() : "";
      const tdsApplicability = tdsRate > 0 ? "Yes" : "No";
      const basicAmount = Number(r.basicAmount) || 0;

      return {
        "Date": invoiceDate.format("DD/MM/YYYY"),
        "Invoice no.": r.billNo || "",
        "Particulars": r._vendor?.vendor_name || "",
        "GSTIN/UIN": r._vendor?.gstno_client_supplier || "",
        "PAN No.": panNo,
        "pan 4 later": fourthLetterOfPan,
        "TDS Applicability": tdsApplicability,
        "Tax Rate": tdsRate,
        "Basic Amount": basicAmount,
        "TDS Amount": tdsAmount,
        "Interest": interest,
        "No. of Months": noOfMonths,
      };
    });

    // Add empty row and total row placeholder
    tdsData.push({
      "Date": "",
      "Invoice no.": "",
      "Particulars": "",
      "GSTIN/UIN": "",
      "PAN No.": "",
      "pan 4 later": "",
      "TDS Applicability": "",
      "Tax Rate": "",
      "Basic Amount": "",
      "TDS Amount": "",
      "Interest": "",
      "No. of Months": "",
    });

    tdsData.push({
      "Date": "",
      "Invoice no.": "",
      "Particulars": "TOTAL",
      "GSTIN/UIN": "",
      "PAN No.": "",
      "pan 4 later": "",
      "TDS Applicability": "",
      "Tax Rate": "",
      "Basic Amount": 0,
      "TDS Amount": 0,
      "Interest": 0,
      "No. of Months": "",
    });

    const ws = utils.json_to_sheet(tdsData);
    
    // Add SUM formulas for total row
    // Row 1 is header, data starts at row 2, total row is at dataLength + 3 (including empty row)
    const totalRowNum = tableData.length + 3;
    const dataEndRow = tableData.length + 1;
    
    // Column I = Basic Amount, J = TDS Amount, K = Interest
    ws[`I${totalRowNum}`] = { t: "n", f: `SUM(I2:I${dataEndRow})` };
    ws[`J${totalRowNum}`] = { t: "n", f: `SUM(J2:J${dataEndRow})` };
    ws[`K${totalRowNum}`] = { t: "n", f: `SUM(K2:K${dataEndRow})` };

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "TDS Report");

    const wbout = write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, `TDS Report ${moment().format("DD-MM-YYYY")}.xlsx`);
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {rejectModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Reject Remark</label>
                <input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-52 p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    updatePayMutate({
                      url: "/admin/vendorpayment/update/" + seletedPayment?.id,
                      data: {
                        status: "REJECTED",
                        remark: remark,
                      },
                    });
                  }}
                >
                  Reject
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setRejectModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {disburseModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-full">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col gap-4 bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 w-full max-w-sm">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">
                  Payment Date:{" "}
                  {seletedPayment.paymentDate ? moment(seletedPayment.paymentDate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "-"}
                </label>
                {/*<input
                  type="date"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  disabled={true}
                />*/}
              </div>

              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font- text-gray-900">Payment Method: {seletedPayment.payType}</label>
                {/*<Select
                  className={`${false ? "bg-gray-300" : ""} w-full bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={GenericColumnData?.vendorpayment?.tableColumnData?.find((d: any) => d.key === "payType")?.options || []}
                  onChange={(e) => {
                    setPayType(e);
                  }}
                  value={payType}
                  isClearable={true}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Payment Ref. No: {seletedPayment.refNo}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Payment Ref. No"
                  value={refNo}
                  onChange={(e) => setRefNo(e.target.value)}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark: {seletedPayment.remark}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />*/}
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    /*if (!paymentDate || !refNo || !payType?.value) {
                      window.alert("Select Valid Value");
                      return;
                    }*/
                    updatePayMutate({
                      url: "/admin/vendorpayment/update/" + seletedPayment?.id,
                      data: {
                        status: "PAID",
                        /*paymentDate: paymentDate,
                        payType: payType?.value || "",
                        refNo: refNo || "",
                        remark: remark || "",*/
                      },
                    });
                  }}
                >
                  Disburse
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setDisburseModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* GST/TDS Paid Confirmation Modal */}
      {gstTdsPaidModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[300px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                {isPaidAction ? "Mark" : "Unmark"} {paidType === "gst" ? "GST" : "TDS"} as {isPaidAction ? "Paid" : "Unpaid"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${isPaidAction ? "text-green-600" : "text-red-600"}`}>
                  Total {paidType === "gst" ? "GST" : "TDS"}: ₹{" "}
                  {getSelectedTotal(paidType!).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${isPaidAction ? "bg-green-500 hover:bg-green-600 focus:ring-green-700" : "bg-red-500 hover:bg-red-600 focus:ring-red-700"}`}
                  onClick={handleConfirmPaid}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : "Confirm"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setGstTdsPaidModalOpen(false);
                    setPaidType(null);
                    setIsPaidAction(true);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Disburse/Reject Confirmation Modal */}
      {bulkActionModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[350px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                Bulk {bulkActionType === "disburse" ? "Disburse" : "Reject"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${bulkActionType === "disburse" ? "text-green-600" : "text-red-600"}`}>
                  Total Payable: ₹{" "}
                  {tableData
                    .filter((row: any) => selectedRows.has(row.id))
                    .reduce((sum: number, row: any) => sum + (Number(row.finalAmount || 0) - Number(row.tds || 0)), 0)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </div>
              {bulkActionType === "reject" && (
                <div className="mb-4">
                  <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Reject Remark"
                    value={bulkRemark}
                    onChange={(e) => setBulkRemark(e.target.value)}
                  />
                </div>
              )}
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${
                    bulkActionType === "disburse"
                      ? "bg-green-500 hover:bg-green-600 focus:ring-green-700"
                      : "bg-red-500 hover:bg-red-600 focus:ring-red-700"
                  }`}
                  onClick={handleConfirmBulkAction}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : bulkActionType === "disburse" ? "Confirm Disburse" : "Confirm Reject"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setBulkActionModalOpen(false);
                    setBulkActionType(null);
                    setBulkRemark("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="flex items-center justify-between px-4 mb-0 mt-1">
        {/* Left: GST & TDS Paid Buttons */}
        <div className="flex gap-2">
          <button
            onClick={() => handlePaidClick("gst", true)}
            type="button"
            className="bg-purple-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Paid
          </button>
          <button
            onClick={() => handlePaidClick("gst", false)}
            type="button"
            className="bg-purple-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Unpaid
          </button>
          <button
            onClick={() => handlePaidClick("tds", true)}
            type="button"
            className="bg-orange-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Paid
          </button>
          <button
            onClick={() => handlePaidClick("tds", false)}
            type="button"
            className="bg-orange-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Unpaid
          </button>
        </div>

        {/* Center: Title & Add New Button */}
        <div className="flex items-center gap-4">
          <h1 className="text-lg font-semibold">Vendor Payment</h1>
          <button
            onClick={() => {
              navigator("/master/vendorpayment/add");
            }}
            type="button"
            className="bg-green-700 text-white px-4 py-1 rounded-md"
          >
            Add New
          </button>
        </div>

        {/* Right: Export Buttons & TDS Report */}
        <div className="flex gap-2">
          <button onClick={exportToExcel} className="bg-blue-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-700">
            Excel Export
          </button>
          <button
            onClick={exportTdsReport}
            className="bg-teal-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-teal-700"
          >
            TDS Report
          </button>
        </div>
      </div>

      <div className="px-2 border-[1px] py-2 mx-2 mt-1 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-2">
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Vendor</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={branchOptions}
                onChange={(e) => {
                  setBranchOtp(e);
                }}
                value={branchOpt}
                isClearable={true}
              />
            </div>
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">City</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={cityOptions}
                onChange={(e) => {
                  setSelectedCity(e);
                }}
                value={selectedCity}
                isClearable={true}
              />
            </div>

            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Status</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-40 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={GenericColumnData?.vendorpayment?.tableColumnData?.find((d: any) => d.key === "status")?.options || []}
                onChange={(e) => {
                  setSelectedStatus(e);
                }}
                value={selectedStatus}
                isClearable={true}
              />
            </div>

            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Bill No</label>
              <input
                type="text"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-28 p-2.5`}
                placeholder="Bill No"
                value={billNoFilter}
                onChange={(e) => setBillNoFilter(e.target.value)}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Ref No</label>
              <input
                type="text"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-2.5`}
                placeholder="Ref No"
                value={ackNoFilter}
                onChange={(e) => setAckNoFilter(e.target.value)}
              />
            </div>

            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full- w-32 p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">To Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-2.5`}
                placeholder="End Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className="px-4 border-[1px] py-2 mx-4 my-1 rounded-md text-center flex items-center justify-center gap-2 flex-wrap">
        {selectedRows.size > 0 &&
          !tableData.some(
            (row: any) => selectedRows.has(row.id) && ["PAID", "REJECTED", "PENDING"].includes(row.status),
          ) && (
            <div className="inline-flex gap-2 flex-col mr-8">
              <Button
                onPress={() => handleBulkAction("disburse")}
                color="success"
                size="sm"
              >
                Bulk Disburse ({selectedRows.size})
              </Button>
              <Button
                onPress={() => handleBulkAction("reject")}
                color="danger"
                size="sm"
              >
                Bulk Reject ({selectedRows.size})
              </Button>
            </div>
          )}
        {Object.keys(kpsTotal).map((kpsKeys) => {
          return (
            <div
              key={kpsKeys + "-kps"}
              className={`border-2 rounded-md p-2 inline-block ${kpsKeys == "PENDING" ? "bg-yellow-200" : ""} ${
                kpsKeys == "VERIFIED" ? "bg-purple-200" : ""
              } ${kpsKeys == "PAID" ? "bg-green-300" : ""}`}
            >
              <p className="font-semibold">
                {kpsKeys || "-"} ({kpsTotal[kpsKeys][0]})
              </p>
              <p className="text-2xl">
                {"₹ " +
                  (Number(kpsTotal[kpsKeys][1]) || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </p>
            </div>
          );
        })}
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{tableData?.length}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1" colSpan={5}>
                {selectedRows.size > 0 && (
                  <span className="text-primary font-inter">
                    Selected Payable: ₹{" "}
                    {tableData
                      .filter((row: any) => selectedRows.has(row.id))
                      .reduce((sum: number, row: any) => sum + (Number(row.finalAmount || 0) - Number(row.tds || 0)), 0)
                      .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    {" "}({selectedRows.size} rows)
                  </span>
                )}
              </th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1 py-2">{totals.base?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.cgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.sgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.igst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.tds).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.payable).toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1">
                <input
                  type="checkbox"
                  checked={tableData?.length > 0 && selectedRows.size === tableData?.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="w-4 h-4 cursor-pointer"
                />
              </th>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Action</th>
              <th className="border border-slate-200 px-1">Vendor</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Pay Date {GET_SORT_ICON("paymentDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Invoice Date {GET_SORT_ICON("invoiceDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">From Date {GET_SORT_ICON("fromDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">To Date {GET_SORT_ICON("toDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Recv Date {GET_SORT_ICON("recvDate", "")}</th>
              <th className="border border-slate-200 px-1">Bill No</th>
              <th className="border border-slate-200 px-1">Basic Amt</th>
              <th className="border border-slate-200 px-1">cgst</th>
              <th className="border border-slate-200 px-1">sgst</th>
              <th className="border border-slate-200 px-1">igst</th>
              <th className="border border-slate-200 px-1">Invoice Amt</th>
              <th className="border border-slate-200 px-1">tds</th>
              <th className="border border-slate-200 px-1">Payable Amt</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Status {GET_SORT_ICON("Status", "asc")}</th>
              <th className="border border-slate-200 px-1">Ref No</th>
              <th className="border border-slate-200 px-1">GST Paid</th>
              <th className="border border-slate-200 px-1">TDS Paid</th>
              <th className="border border-slate-200 px-1">-</th>
              <th className="border border-slate-200 px-1">Remark</th>
              <th className="border border-slate-200 px-1">File</th>
              <th className="border border-slate-200 px-1">Ack No</th>
              <th className="border border-slate-200 px-1">Days</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr
                    key={"r" + r.id}
                    className={`${
                      r.status == "PAID"
                        ? "bg-green-300"
                        : r.status == "REJECTED"
                          ? "bg-red-300"
                          : r.status == "PENDING"
                            ? "bg-yellow-200"
                            : r.status == "VERIFIED"
                              ? "bg-purple-200"
                              : ""
                    }`}
                  >
                    <td className="border border-slate-200 px-2">
                      <input
                        type="checkbox"
                        checked={selectedRows.has(r.id)}
                        onChange={(e) => handleRowSelect(r.id, e.target.checked)}
                        className="w-4 h-4 cursor-pointer"
                      />
                    </td>
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">
                      {userDetails.roleName != roles.SUPER_ADMIN && !["PAID", "REJECTED", "VERIFIED"].includes(r.status) && (
                        <button
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure!",
                              html: `${r._vendor.vendor_name}<br>Amount:${r.finalAmount}`,
                              icon: "question",
                              confirmButtonText: "Verify Invoice",
                              showCancelButton: true,
                            }).then((x) => {
                              if (x.isConfirmed) {
                                updatePayMutate({
                                  url: "/admin/vendorpayment/update/" + r?.id,
                                  data: {
                                    status: "VERIFIED",
                                  },
                                });
                              }
                            });
                          }}
                          className="text-white bg-purple-800 px-2 py-1 rounded-md mt-1"
                        >
                          Verify
                        </button>
                      )}
                      {userDetails.roleName == roles.SUPER_ADMIN && !["PAID", "REJECTED", "PENDING"].includes(r.status) && (
                        <button
                          onClick={() => {
                            //onStateChange("DISBURSED");
                            setDisburseModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-green-600 px-1 py-0.5 text-sm rounded-md"
                        >
                          Disburse
                        </button>
                      )}
                      {!["PAID", "REJECTED"].includes(r.status) && (
                        <button
                          onClick={() => {
                            setRejectModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-red-600 px-2 py-1 rounded-md mt-1"
                        >
                          Reject
                        </button>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2">{r._vendor?.vendor_name}</td>
                    <td className="border border-slate-200 px-2">
                      {r.paymentDate != "Invalid Date" ? moment(r.paymentDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">{moment(r.invoiceDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.fromDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.toDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.recvDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{r.billNo}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.basicAmount}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.cgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.sgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.igst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.finalAmount}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.tds}</td>
                    <td className="border border-slate-200 px-2 text-right">{(r.finalAmount - r.tds).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r.status}</td>
                    <td className="border border-slate-200 px-2">{r.refNo}</td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${r.gstPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {r.gstPaid ? "Yes" : "No"}
                    </td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${r.tdsPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {r.tdsPaid ? "Yes" : "No"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      <button
                        onClick={() => {
                          //navigator(`/master/vendorpayment/list/${r.id}`);
                          window.open(`/master/vendorpayment/list/${r.id}`, "_blank");
                        }}
                        className="text-blue-500"
                      >
                        View
                      </button>
                      <br />
                      <button
                        onClick={() => {
                          let confirm_ = window.confirm("Are you sure");
                          if (confirm_) {
                            deleteVendorPayment(r.id);
                          }
                          //navigator(`/master/vendorpayment/list/${r.id}`);
                        }}
                        className="text-red-500"
                      >
                        Delete
                      </button>
                    </td>
                    <td className="border border-slate-200 px-2">{r.remark}</td>
                    <td className="border border-slate-200 px-2">
                      {r.fileUrl ? (
                        (() => {
                          // Parse fileUrl format: invoiceUrl|ab1,ab2,ab3
                          const [invoiceUrl, airwaybillsStr] = r.fileUrl.includes("|") ? r.fileUrl.split("|") : [r.fileUrl, ""];
                          const airwaybills = airwaybillsStr ? airwaybillsStr.split(",").filter(Boolean) : [];
                          const isAwbDropdownOpen = openAwbDropdownId === r.id;

                          return (
                            <div className="flex flex-col gap-1 relative">
                              {invoiceUrl && (
                                <div className="flex items-center gap-1">
                                  <span className="text-xs text-gray-600">Inv:</span>
                                  <a
                                    href={invoiceUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="text-blue-500 hover:text-blue-700 inline-block"
                                    title="Download Invoice"
                                  >
                                    <ArrowDownTrayIcon className="h-4 w-4" />
                                  </a>
                                </div>
                              )}
                              {airwaybills.length > 0 && (
                                <div className="flex items-center gap-1 relative">
                                  <span className="text-xs text-gray-600">AWB:</span>
                                  <button
                                    onClick={() => setOpenAwbDropdownId(isAwbDropdownOpen ? null : r.id)}
                                    className="flex items-center gap-1 px-2 py-0.5 bg-green-100 hover:bg-green-200 rounded text-xs text-green-700 font-semibold"
                                    title="View Airwaybill Files"
                                  >
                                    <ArrowDownTrayIcon className="h-3 w-3" />
                                    <span>{airwaybills.length}</span>
                                  </button>

                                  {isAwbDropdownOpen && (
                                    <>
                                      <div className="fixed inset-0 z-10" onClick={() => setOpenAwbDropdownId(null)}></div>
                                      <div className="absolute right-0 top-6 z-20 bg-white border border-gray-300 rounded-lg shadow-lg p-2 min-w-[180px] max-h-[300px] overflow-y-auto">
                                        <div className="text-xs font-semibold text-gray-700 mb-2 pb-2 border-b">
                                          Airwaybill Files ({airwaybills.length})
                                        </div>
                                        {airwaybills.map((url, idx) => (
                                          <a
                                            key={idx}
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                            className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-100 rounded text-xs text-gray-700 group"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <ArrowDownTrayIcon className="h-3.5 w-3.5 text-green-600 group-hover:text-green-700" />
                                            <span className="flex-1 truncate">AWB {idx + 1}</span>
                                          </a>
                                        ))}
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2">{r.id}</td>
                    <td className="border border-slate-200 px-2">
                      {r.status != "DISBURSED" && r.status != "PAID"
                        ? moment().diff(moment(r.recvDate, "DD-MM-YYYY HH:mm:ss"), "days")
                        : "-"}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default VendorPayList;
